<template>
    <div class="com-codics-hbb-order-admin-goods-add-body">
        <div class="iconfont com-codics-hbb-order-admin-goods-add-back" @click="jumpToPage('商品管理', {}, {})">&#xe842;
            返回页面
        </div>
        <div class="com-codics-hbb-order-admin-goods-add-bar-content"
            style="width:100% !important;padding:50px 0 !important;">
            <MyStep v-model="stepNum" :data="stepData" :size="10"></MyStep>
        </div>
        <div class="com-codics-hbb-order-admin-goods-add-bar-content com-codics-hbb-order-admin-goods-add-bar-content2"
            style="margin-top: 10px;">
            <el-form v-show="stepNum == 1" :model="addForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="商品封面(最多10张)" required>
                    <MyUpload v-model="himgList" multiple :limit="10"></MyUpload>
                </el-form-item>
                <el-form-item label="图片介绍">
                    <MyUpload v-model="dimgList" multiple :limit="30"></MyUpload>
                </el-form-item>
                <el-form-item label="商品视频(5秒-5分)">
                    <MyUpload v-model="videoList" accept="video/*" multiple :limit="1"></MyUpload>
                    <span style="margin-left: 15px;" v-show="videoList.length > 0"><span class="iconfont"
                            style="color:red;">&#xe85c;</span>上传视频后草稿功能保存数量将大幅缩进，无法保存时请移除视频后再保存草稿！</span>
                </el-form-item>
            </el-form>
            <el-form v-show="stepNum == 2" :model="addForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="商品名称" required>
                    <el-input v-model="addForm.title" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="商品介绍" required>
                    <el-input type="textarea" v-model="addForm.detail" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="购买须知">
                    <el-input v-model="addForm.tip" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" required>
                    <el-cascader v-model="addForm.type" style="width:380px;float:left;" placeholder="请选择商品分类"
                        :options="typeOptions" :props="{ checkStrictly: true }" clearable></el-cascader>
                    <MyButton style="margin-left:15px;" @click.native="jumpToPage('分类管理', {}, {})">没有？去创建</MyButton>
                </el-form-item>
                <el-form-item label="商品品牌" required>
                    <el-cascader v-model="addForm.brand" style="width:380px;float:left;" placeholder="请选择商品品牌"
                        :options="brandOptions" :props="{ checkStrictly: true }" clearable></el-cascader>
                    <MyButton style="margin-left:15px;" @click.native="jumpToPage('品牌管理', {}, {})">没有？去创建</MyButton>
                </el-form-item>
                <el-form-item label="商品标签" required>
                    <el-tag v-for="(tag, index2) in addForm.tags" :key="index2" closable :disable-transitions="false"
                        style="margin-right: 10px;" :type="['', 'success', 'warning', 'danger'][index2 % 4]"
                        @close="handleTagClose(tag)">
                        {{ tag.tag }}
                    </el-tag>
                    <el-input style="width:90px !important;margin-right:10px;" v-if="inputTagVisible"
                        v-model="inputTagValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>
                    <el-button style="width:90px !important;margin-right:10px;" v-else class="button-new-tag"
                        size="small" @click="showInput">+ 新建标签</el-button>
                </el-form-item>
                <el-form-item label="商品产地" required>
                    <el-cascader style="width:380px;" :props="{ checkStrictly: true }" size="large" filterable
                        :options="areaOptions" v-model="addForm.origin" clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="商品状态" required>
                    <el-select v-model="addForm.state" placeholder="请选择商品状态" style="width:380px;">
                        <el-option v-for="item in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详情链接">
                    <el-input style="position:relative;float:left;width:380px;" v-model="addForm.url"
                        clearable></el-input>
                    <MyButton style="margin-left:15px;" @click.native="openBindDialog">绑定详情链接</MyButton>
                </el-form-item>
            </el-form>
            <MyButton v-show="stepNum == 3" style="left:50%;transform:translateX(-50%);" @click.native="addGoodsInfo">
                添加销售参数</MyButton>
            <el-form v-show="stepNum == 4" :model="addForm" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="是否包邮" required>
                    <el-select v-model="addForm.ts" placeholder="请选择是否包邮" style="width:380px;">
                        <el-option v-for="item in [{ value: 0, label: '包邮' }, { value: 1, label: '不包邮' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin-left: 15px;" v-show="addForm.ts == 1"><span class="iconfont"
                            style="color:red;">&#xe85c;</span>不包邮时需要您在”邮费时效信息“栏目内进行说明！</span>
                </el-form-item>
                <el-form-item label="物流类型" required>
                    <el-select v-model="addForm.tt" placeholder="请选择物流类型" style="width:380px;">
                        <el-option v-for="item in wuliuData" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin-left: 15px;" v-show="addForm.tt == 'qitafangshi'"><span class="iconfont"
                            style="color:red;">&#xe85c;</span>当前物流方式需要您在”邮费时效信息“栏目内进行说明！</span>
                </el-form-item>
                <el-form-item label="邮费时效信息">
                    <el-input type="textarea" v-model="addForm.ttime" style="width:380px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div v-show="stepNum == 3" v-for="(item, index) in addForm?.info" :key="index"
            class="com-codics-hbb-order-admin-goods-add-bar-content com-codics-hbb-order-admin-goods-add-bar-content2"
            style="margin-top: 10px;">
            <el-form v-show="!item.small" :model="addForm?.info[index]" label-width="160px" style="margin-top: 30px;">
                <el-form-item label="销售参数封面" required>
                    <MyUpload v-model="addForm.info[index].img" multiple :limit="1"></MyUpload>
                </el-form-item>
                <el-form-item label="销售参数标题" required>
                    <el-input v-model="addForm.info[index].title" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="当前规格原价" required>
                    <el-input-number v-model="addForm.info[index].op" :precision="2" :step="0.01"
                        :max="9999999"></el-input-number>
                </el-form-item>
                <el-form-item label="当前规格现价" required>
                    <el-input-number v-model="addForm.info[index].np" :precision="2" :step="0.01"
                        :max="9999999"></el-input-number>
                </el-form-item>
                <el-form-item label="当前规格库存" required>
                    <el-input-number v-model="addForm.info[index].inventory" :precision="0" :step="1" :min="0"
                        :max="9999999"></el-input-number>
                </el-form-item>
                <el-form-item label="销售参数单位" required>
                    <el-input v-model="addForm.info[index].unit" style="width:380px;"></el-input>
                </el-form-item>
                <el-form-item label="当前规格状态" required>
                    <el-select v-model="addForm.info[index].state" placeholder="请选择当前规格状态" style="width:380px;">
                        <el-option v-for="item in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="当前规格备注">
                    <el-input type="textarea" v-model="addForm.info[index].detail" style="width:380px;"></el-input>
                </el-form-item>
            </el-form>
            <div v-show="item.small" class="com-codics-hbb-order-admin-goods-add-info-item">
                <el-image class="com-codics-hbb-order-admin-goods-add-info-item-img"
                    :src="'https://cdn.bosscaigou.com/' + item.img" fit="contain"></el-image>
                <div class="com-codics-hbb-order-admin-goods-add-info-item-title">{{ item.title }}</div>
                <div class="com-codics-hbb-order-admin-goods-add-info-item-price">
                    <span>原价：￥{{ item.op || 0 }}</span>
                    <span style="margin-left:30px;">现价：￥{{ item.np || 0 }}</span>
                    <span style="margin-left:30px;">库存：{{ item.inventory || 0 }}</span>
                    <span style="margin-left:30px;">状态：{{ ['上架','下架'][item.state || 0] }}</span>
                    <span style="margin-left:30px;">备注：{{ item.remark }}</span>
                </div>
            </div>
            <MyButton class="com-codics-hbb-order-admin-goods-add-info-item-del-btn" type="danger"
                @click.native="deleteInfoItem(index);">&#xe850;</MyButton>
            <div class="iconfont com-codics-hbb-order-admin-goods-add-info-item-delete"
                @click="item.small = !item.small;" v-html="item.small ? '&#xe83d;' : '&#xe857;'"></div>
        </div>
        <div class="com-codics-hbb-order-admin-goods-add-bottom-bar">
            <el-button v-show="stepNum < 5" @click="nextStep" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                :type="stepNum == 4 ? 'success' : 'primary'">{{ stepNum == 4 ? '上传商品信息' : '确认，下一步' }}</el-button>
            <el-dropdown v-show="stepNum < 5" split-button type="warning" size="small" plain
                style="float:right;top:50%;transform:translateY(-50%);margin-right:10px;" @click="savaRecord"
                @command="handleCommandClick">
                保存草稿
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in recordData" :key="index" :command="item">{{ item.title
                        }}&nbsp;&nbsp;&nbsp;<span class="iconfont" style="float:right;"
                            @click.stop="delRecord(item)">&#xe850;</span><span style="float:right;">{{
                            initTime(item.time) }}&nbsp;&nbsp;&nbsp;</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button v-show="stepNum > 1 && stepNum < 5" @click="lastStep" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                type="">返回上一步</el-button>
            <el-button v-show="stepNum == 5" @click="jumpToPage('商品管理', {}, {})" size="small"
                style="position:relative;float:right;top:50%;transform:translateY(-50%);margin-right:10px"
                type="success">返回管理页面</el-button>
        </div>
        <MyDialog v-model="bindUrlVisible" title="绑定详情链接" width="80%">
            <iframe ref="urlIframe" style="width:100%;height:70vh;position:relative;float:right;" :src="nowUrl"
                frameborder="0"></iframe>
            <MyButton style="margin-top:20px;margin-bottom:20px;float:right;" @click.native="bindUrlFuc">绑定当前页面
            </MyButton>
        </MyDialog>
    </div>
</template>


<script>
import dayjs from 'dayjs';
import MyStep from '@/components/MyStep';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { addGoods, getQiNiuToken, listGoodsBrand, listGoodsType } from '@/api';
import { jumpTo, saveData, readData, delData, randomString } from '@/utils/myutils';
import Sortable from 'sortablejs';
import * as qiniu from 'qiniu-js';
import { hex_md5 } from '@/utils/md5';
import MyUpload from '@/components/MyUpload';
// import { regionData, codeToText, TextToCode } from "element-china-area-data";
import areaData from '../../../../public/data/data2.json';
export default {
    data() {
        return {
            inputTagVisible: false,
            inputTagValue: '',
            nowUrl: '',
            bindUrlVisible: false,
            stepNum: 1,
            stepData: [
                {
                    icon: '&#xe808;',
                    title: '图片信息',
                    content: '按照指定的方式拍摄图片，并按照图片格式要求完成商品图片的添加'
                },
                {
                    icon: '&#xe7b8;',
                    title: '基础信息',
                    content: '按照商品具体的属性进行填写，标记星号的为必填项'
                },
                {
                    icon: '&#xe79e;',
                    title: '销售信息',
                    content: '根据商品的尺寸、重量、体积等属性，按销售价格的不同生成销售选项'
                },
                {
                    icon: '&#xe6d6;',
                    title: '物流服务',
                    content: '请按照物流的方式，时效，价格等生成物流选项，有前提条件的包邮请备注'
                },
                {
                    icon: '&#xe84c;',
                    title: '完成添加',
                    content: '商品添加完成，手动返回或等待页面完成自动跳转'
                }
            ],
            qiNiuInfo: {
                token: ''
            },
            typeOptions: [],
            brandOptions: [],
            himgList: [],
            dimgList: [],
            videoList: [],
            recordData: [],
            areaOptions: areaData,
            wuliuData: [
                {
                    value: 'shunfeng',
                    label: '顺丰快递'
                },
                {
                    value: 'zhongtong',
                    label: '中通快递'
                },
                {
                    value: 'yuantong',
                    label: '圆通快递'
                },
                {
                    value: 'shentong',
                    label: '申通快递'
                },
                {
                    value: 'jtexpress',
                    label: '极兔快递'
                },
                {
                    value: 'yunda',
                    label: '韵达快递'
                },
                {
                    value: 'jd',
                    label: '京东快递'
                },
                {
                    value: 'ems',
                    label: '邮政快递'
                },
                {
                    value: 'qitafangshi',
                    label: '其他方式'
                }
            ],
            addForm: {
                himg: '',
                dimg: '',
                video: '',
                title: '',
                detail: '',
                tip: '',
                type: null,
                brand: null,
                origin: '',
                sid: 0,
                state: 0,
                url: '',
                ts: 0,
                tt: '',
                ttime: '',
                tags: [
                    {
                        tag: '牛'
                    }
                ],
                info: [
                ]
            },
            himgSize: 0
        }
    },
    components: {
        MyButton,
        MyStep,
        MyUpload,
        MyDialog
    },
    mounted() {
        this.listGoodsBrandFuc();
        this.listGoodsTypeFuc();
        this.readRecord();
        // this.initAreaData(this.areaOptions, "COUNTRIES", 0);
        // this.initValue(this.areaOptions);
    },
    methods: {
        // initValue(t) { 
        //     t.forEach(item => { 
        //         item.value = item.label;
        //         if (item.children) this.initValue(item.children);
        //     })
        // },
        handleTagClose(tag) {
            this.addForm.tags = this.addForm.tags.filter(item => item.tag != tag.tag);
        },
        handleInputConfirm() {
            let inputValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputValue) {
                this.addForm.tags.push({
                    tag: inputValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput() {
            this.inputTagVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleCommandClick(item) {
            this.addForm = item.addForm;
            this.himgList = item.himgList;
            this.dimgList = item.dimgList;
            this.videoList = item.videoList;
            this.$message({
                showClose: true,
                message: '记录恢复成功！',
                type: 'success'
            });
        },
        async initAreaData(t, txt, count) {
            count++;
            Object.keys(areaData[txt]).forEach(key => {
                let tt = count == 1 ? {
                    value: areaData[txt][key],
                    label: areaData[txt][key],
                    children: []
                } : {
                    value: areaData[txt][key],
                    label: areaData[txt][key],
                };
                t.push(tt)
                count < 2 && this.initAreaData(tt.children, key, count);
            });
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                this.$message.error(data.message);
            }
        },
        openBindDialog() {
            this.bindUrlVisible = true;
            const el = this.$refs.urlIframe;
            el.src = 'https://www.bosscaigou.com/all_products.html';
        },
        bindUrlFuc() {

            const el = this.$refs.urlIframe;
            el.contentWindow.postMessage('getURL', '*');
            // 监听iframe返回的消息
            window.addEventListener('message', (event) => {
                if (event.data.type === 'currentURL') {
                    this.bindUrlVisible = false;
                    console.log('iframe当前URL:', event.data.url);
                    this.addForm.url = event.data.url;
                }
            });
        },
        async nextStep() {

            if (this.stepNum == 1) {

                if (this.himgList.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先上传商品封面！',
                        type: 'warning'
                    });

                    return true;

                }

                this.stepNum++;

            } else if (this.stepNum == 2) {

                if (this.addForm.title == '') {

                    this.$message({
                        showClose: true,
                        message: '请先填写商品名称！',
                        type: 'warning'
                    });

                    return;

                } else if (this.addForm.detail == '') { // 商品介绍

                    this.$message({
                        showClose: true,
                        message: '请先填写商品介绍！',
                        type: 'warning'
                    });

                    return;

                } else if (this.addForm.type == null) { // 商品分类

                    this.$message({
                        showClose: true,
                        message: '请先选择商品分类！',
                        type: 'warning'
                    });

                    return;

                } else if (this.addForm.brand == null) { // 商品品牌

                    this.$message({
                        showClose: true,
                        message: '请先选择商品品牌！',
                        type: 'warning'
                    });

                    return;

                } else if (this.addForm.origin == '') { // 商品产地

                    this.$message({
                        showClose: true,
                        message: '请先选择商品产地！',
                        type: 'warning'
                    });

                    return;

                } else if (this.addForm.state == null) { // 商品库存

                    this.$message({
                        showClose: true,
                        message: '请先填写商品状态！',
                        type: 'warning'
                    });

                    return;

                }

                this.stepNum++;

            } else if (this.stepNum == 3) {

                if (this.addForm.info == null || this.addForm.info.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先添加商品销售参数！',
                        type: 'warning'
                    });

                    return;

                }

                let flag = true;

                this.addForm.info.forEach(item => {

                    if (item.img == '') {

                        this.$message({
                            showClose: true,
                            message: '请先上传商品销售参数封面！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.title == '') {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数标题！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.op == null) {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数原价！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.np == null) {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数现价！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.inventory == null) {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数库存！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.unit == null) {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数单位！',
                            type: 'warning'
                        });

                        flag = false;

                    } else if (item.state == null) {

                        this.$message({
                            showClose: true,
                            message: '请先填写商品销售参数状态！',
                            type: 'warning'
                        });

                        flag = false;

                    }

                });

                if (!flag) {

                    return;

                }

                this.stepNum++;

            } else if (this.stepNum == 4) {

                if (this.addForm.ts == null && this.addForm.tt == null) {

                    this.$message({
                        showClose: true,
                        message: '请先填写邮费及物流信息！',
                        type: 'warning'
                    });

                    return;

                }

                // this.stepNum++;

                this.addForm.type = this.addForm.type[this.addForm.type.length - 1];

                this.addForm.brand = this.addForm.brand[this.addForm.brand.length - 1];

                this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;

                this.addForm.origin = this.addForm.origin.join('/');

                this.addForm.ttime = this.addForm.ttime == null ? '' : this.addForm.ttime;

                this.addForm.himg = this.himgList.join(',');

                this.addForm.dimg = this.dimgList.join(',');

                this.addForm.video = this.videoList[0]?.video || '';

                this.addForm?.info.forEach(item => {

                    item.img = item.img.join(',');

                });

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const data = await addGoods(this.addForm);

                loading.close();

                if (data.code == 200) {

                    this.stepNum++;

                } else {

                    this.$message.error(data.message);

                }

            } else if (this.stepNum == 5) {

                this.$message({
                    showClose: true,
                    message: '商品添加成功！',
                    type: 'success'
                });
            }
        },
        lastStep() {
            this.stepNum--;
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listGoodssFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listGoodssFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        addGoodsCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodssFuc();

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goods - addType,
                brand: this.goods - addBrand
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        async repassGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassGoodss({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteGoodssFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteGoodss({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listGoodssFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listGoodssFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        // 上传方法
        uploadHimg(uploadInfo) {

            // this.initDragSort(this.$refs.himgUpload, this.himgList);

            if (this.himgList.length >= 5) {
                this.$message({
                    showClose: true,
                    message: '最多上传5张图片！',
                    type: 'warning'
                });
                return;
            }

            this.himgList.push('huayuan/img/' + hex_md5(uploadInfo.file.name) + '_' + new Date().getTime() + '.png');

            this.himgSize = this.himgList.length;

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    console.log(res.key)
                    console.log(_that.himgList.length)

                }
            }
            // console.log(uploadInfo.file);
            const observable = qiniu.upload(uploadInfo.file, 'huayuan/img/' + hex_md5(uploadInfo.file.name) + '_' + new Date().getTime() + '.png', this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        initDragSort(el, list) {
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    // 交换位置
                    const arr = list;
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);

                }
            });
        },
        handleRemove(file) {
            this.himgList = this.himgList.filter(item => item.indexOf(file.name.replace(',', '')) == -1);
            this.himgSize = this.himgList.length;
        },
        savaRecord() {
            if (this.addForm.title == '') {
                this.$message({
                    showClose: true,
                    message: '请先填写商品名称再尝试保存！',
                    type: 'warning'
                });
                return;
            }
            let data = readData("codics-hbb-goods-add-record");
            console.log(data);
            if (data == null) {
                let t = [];
                t.push({
                    'tid': 'CHGAR-' + randomString(10) + '-' + new Date().getTime(),
                    'title': this.addForm.title,
                    'time': new Date(),
                    'addForm': this.addForm,
                    'himgList': this.himgList,
                    'dimgList': this.dimgList,
                    'videoList': this.videoList
                });
                saveData("codics-hbb-goods-add-record", JSON.stringify(t));
            } else {
                let t = JSON.parse(data);
                if (t.length >= 10) {
                    this.$message({
                        showClose: true,
                        message: '保存数量到上限，请删除部分后再尝试保存！',
                        type: 'warning'
                    });
                    return;
                }
                t.push({
                    'tid': 'CHGAR-' + randomString(10) + '-' + new Date().getTime(),
                    'title': this.addForm.title,
                    'time': new Date(),
                    'addForm': this.addForm,
                    'himgList': this.himgList,
                    'dimgList': this.dimgList,
                    'videoList': this.videoList
                });
                saveData("codics-hbb-goods-add-record", JSON.stringify(t));
            }
            this.readRecord();
            this.$message({
                showClose: true,
                message: '记录保存成功！',
                type: 'success'
            });
        },
        readRecord() {
            this.recordData = [];
            let data = readData("codics-hbb-goods-add-record");
            this.recordData = data == null ? [] : JSON.parse(data);
        },
        delRecord(itm) {
            let t = JSON.parse(readData("codics-hbb-goods-add-record"));
            t = t.filter(item => item.tid != itm.tid);
            saveData("codics-hbb-goods-add-record", JSON.stringify(t));
            this.readRecord();
            this.$message({
                showClose: true,
                message: '记录删除成功！',
                type: 'success'
            });
        },
        addGoodsInfo() {
            let arr = this.addForm.info == null ? [] : this.addForm.info;
            arr.forEach(item => {
                item.small = true;
            });
            arr.push({
                'img': [],
                'title': '',
                'op': 0,
                'np': 0,
                'inventory': 0,
                'remark': '',
                'state': 0,
                'small': false
            });
            this.addForm.info = arr;
        },
        deleteInfoItem(idx) {
            this.addForm.info.splice(idx, 1);
        }
    },
    computed: {
        listAddState() {

            return this.$refs['fmUpload'] < 5;

        }
    }
}
</script>

<style>
.com-codics-hbb-order-admin-goods-add-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --goods-add-back-font-color: #333;
    --goods-add-bottom-bg-color: #FFF;
    --goods-add-bottom-shadow-color: #EBEBEB;
}

:root[data-theme="dark"] {
    --goods-add-back-font-color: #FFF;
    --goods-add-bottom-bg-color: #292b2c;
    --goods-add-bottom-shadow-color: #2E3235;
}

.com-codics-hbb-order-admin-goods-add-back {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 50px;
    box-sizing: border-box;
    font-size: 14px;
    color: var(--goods-add-back-font-color);
    font-weight: bolder;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    margin-bottom: 5px;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-goods-add-bottom-bar {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFF;
    background: var(--goods-add-bottom-bg-color);
    border: 1px solid #EBEBEB;
    border: 1px solid var(--goods-add-bottom-shadow-color);
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-add-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-add-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-goods-add-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-goods-add-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-img-upload .el-upload {
    display: var(--dataSize);
}

/* .com-codics-hbb-order-admin-goods-add-info-box{
    height:fit-content;
} */

.com-codics-hbb-order-admin-goods-add-info-item-delete {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
    font-size: 15px;
    color: #333;
    text-align: center;
    margin-top: 15px;
}

.com-codics-hbb-order-admin-goods-add-info-item-delete::before {
    content: '';
    height: 1px;
    width: 95%;
    position: absolute;
    margin: auto;
    left: 0;
    top: -15px;
    right: 0;
    background: #EBEBEB;
}

.com-codics-hbb-order-admin-goods-add-info-item-delete:hover {
    background: rgba(0, 0, 0, .3);
}

.com-codics-hbb-order-admin-goods-add-info-item-del-btn {
    position: absolute;
    margin: auto;
    top: 50px;
    right: 20px;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-hbb-order-admin-goods-add-info-item {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.com-codics-hbb-order-admin-goods-add-info-item-img {
    height: 100px;
    width: 100px;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-goods-add-info-item-title {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}

.com-codics-hbb-order-admin-goods-add-info-item-price {
    height: 50px;
    width: calc(100% - 200px);
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    text-align: left;
    padding-left: 20px;
}
</style>